/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Indicates if the card supports domestic pull-from-card transfer.
 */
export const DomesticPullFromCard = {
  NotSupported: "not-supported",
  Supported: "supported",
  Unknown: "unknown",
} as const;
/**
 * Indicates if the card supports domestic pull-from-card transfer.
 */
export type DomesticPullFromCard = ClosedEnum<typeof DomesticPullFromCard>;

/** @internal */
export const DomesticPullFromCard$inboundSchema: z.ZodNativeEnum<
  typeof DomesticPullFromCard
> = z.nativeEnum(DomesticPullFromCard);
/** @internal */
export const DomesticPullFromCard$outboundSchema: z.ZodNativeEnum<
  typeof DomesticPullFromCard
> = DomesticPullFromCard$inboundSchema;
